import React from 'react';

import {AuditProvider} from "../providers/AuditProvider"
import Result from "./result"

const ResultPage = () => {
    return <AuditProvider>
                <Result />
            </AuditProvider>
}

export default ResultPage